<template>
<div class="visual-process">
     <h3>{{ produktnaam }}verzekering</h3>
		<div class="grid-container">

			<step1schademelden-component
					:ctx="ctx"
					:schademeldenurl="schademeldenurl"
			></step1schademelden-component>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-archive clean"></p>
				</div>
				<h4>In behandeling</h4>
				<p>Wij nemen uw schademelding binnen 48 uur in behandeling.</p>
				<a href="#" data-toggle="modal" data-target="#behandelingmodal" >Lees meer</a>
			</div>

			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-user clean"></p>
				</div>
				<h4>Wacht op uw reactie</h4>
				<p>Voor de afhandeling van uw schade hebben wij aanvullende gegevens van u nodig. Hiervan ontvangt u van ons bericht per e-mail en in uw berichtenbox.</p>
			</div>

			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-shield clean"></p>
				</div>
				<h4>Beoordeling</h4>
				<p>Zodra alle gegevens bekend zijn, wordt de schade beoordeeld en z.s.m. afgewikkeld.</p>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-check clean"></p>
				</div>
				<h4>Afgehandeld</h4>
				<p>Wij hebben uw dossier gesloten.</p>
			</div>

		</div>


	<!-- Modal -->
			<div class="modal fade" id="behandelingmodal" tabindex="-1" role="dialog" aria-hidden="true">
			  <div class="modal-dialog" role="document">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h5 class="modal-title">In behandeling</h5>
			        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			          <span aria-hidden="true">x</span>
			        </button>
			      </div>
			      <div class="modal-body">
			        <p>Hierin vragen wij aanvullende informatie bij u op zoals nota's, boekingsbescheiden, politieaangifte etc. Medische kosten kunt u eerst bij uw zorgverzekeraar declareren. Als de zorgverzekeraar de kosten niet of gedeeltelijk vergoedt, kunt u de bewijzen hiervan naar ons toesturen.</p>
					  <br />
			        <h4>Bij annulering van uw reis</h4>
					<p>Hierin vragen wij aanvullende informatie bij u op zoals boekingsbescheiden en de annuleringsnota. Daarnaast eventueel de reden van annulering. U dient de reden van annulering aan te tonen door noodzakelijk aantoonbaar bewijs te overleggen.</p>	
			      </div>
			      <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-modal-close">OK</button>	
			      </div>
			    </div>
			  </div>
			</div>
		<!-- end Modal -->



</div> 
</template>

<script>

    import step1SchadeMelden from './step1schademelden.vue'

export default {
  name: 'schadeproces-component',
    components: {
        'step1schademelden-component': step1SchadeMelden
    },
  props: {	  
	  ctx: String,
      produktnaam: String,
      schademeldenurl: String,
  },
  data: function () {
    return {    	
     }
  } 
  
}

</script>




// WEBPACK FOOTER //
// reis.vue?d2350212